import { observer } from 'mobx-react-lite'
import { Box, SpinnerLoader } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { useCreateContext } from 'pages/clients/pages/create/context/createContext'

export const DuplicateField = observer(() => {
  const { clientDetailsStore } = useCreateContext()
  const {
    clientsLoading,
    clientListDropdownItems,
    selectedDuplicateClientId,
    setSelectedDuplicateClient,
    isDuplicateTableAction,
  } = clientDetailsStore

  return (
    <Box marginTop={isDuplicateTableAction ? '33px' : '12px'}>
      {clientsLoading ? (
        <SpinnerLoader ariaLabel='DuplicateFieldLoader' />
      ) : (
        <SelectField
          labelProps={{
            label: {
              text: 'Duplicated from',
            },
            questionTooltipProps: {
              breakWord: true,
              label: (
                <>
                  This is what we will clone when creating the new organization:
                  <br />
                  <br />
                  • Tags
                  <br />
                  • Custom Fields
                  <br />
                  • Saved Replies
                  <br />
                  • Keywords
                  <br />• Triggers
                </>
              ),
            },
          }}
          items={clientListDropdownItems}
          value={selectedDuplicateClientId}
          setValue={setSelectedDuplicateClient}
          placeholder='Choose client'
          withSearch
          selectProps={{
            variant: 'stroke',
            textFieldPlaceholderProps: {
              size: 'medium',
            },
          }}
        />
      )}
    </Box>
  )
})
